module.exports = __webpack_public_path__ + "static/media/21ECLAC37.a079fd6c.jpg";